import { node, shape, string } from "prop-types";
export var propTypes = {
  pictogram: shape({
    id: string
  }).isRequired,
  title: node.isRequired,
  description: node.isRequired
};
export var defaultProps = {
  children: null
};